import type { Vector3Tuple } from 'three';

import { getEnvValue } from '@/package';

export const getColorByLabel = (label?: string): string =>
  getEnvValue(`VITE_APP_LABELING_COLOR_${(label ?? 'car').toUpperCase()}`);

export const getDarkColorByLabel = (label?: string): string =>
  getEnvValue(`VITE_APP_LABELING_DARK_COLOR_${(label ?? 'car').toUpperCase()}`);

export const getDimensionByLabel = (label?: string): Vector3Tuple => {
  return getEnvValue(
    `VITE_APP_LABELING_SIZE_${(label ?? 'car').toUpperCase()}`,
    value => value.split(','),
  );
};
